import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Page from './components/page';
import ProtectedRoute, { AdminRoute, HyriaAdminRoute } from './components/PrivateRoute';
import EmailConfirmationOne from './containers/brfConfirmations/emailConfirmationOne';
import EmailConfirmationTwo from './containers/brfConfirmations/emailConfirmationTwo';
import Create from './containers/create';
import HomeV3 from './containers/home/HomeV3';
import TenantBackgroundControl from './containers/hyira/tenantBackgroundControl';
import SignIn from './containers/signIn';
import DevLogin, { DEV_LOGIN_ENABLED } from './containers/devLogin';
import TenantConfirmation from './containers/tenantConfirmation';
import DocumentPage from './containers/documents';
import VerifySignIn from './containers/verifySignIn';
import MyApplications from './containers/applications';
import DashboardLayout from './containers/dashboard';
import Applications from './containers/dashboard/Applications';
import Units from './containers/dashboard/Units';
import Documents from './containers/dashboard/Documents';
import Settings from './containers/dashboard/Settings';
import ExportImport from './containers/dashboard/ExportImport';
import CreditChecks from './containers/dashboard/CreditChecks';
import SubletAudit from './containers/dashboard/SubletAudit';
import AuditReportOrder from './containers/dashboard/AuditReportOrder';
import { devAutoLogin } from './api/devAutoLogin';
import DashboardOverview from './containers/dashboard/Overview';
import BankIDAuthTest from './containers/bankidAuthTest';
import HyriaDashboardLayout from './containers/dashboard/HyriaDashboardLayout';
import HyriaOverview from './containers/dashboard/HyriaOverview';
import HyriaAssociations from './containers/dashboard/HyriaAssociations';
import AssociationDetail from './containers/dashboard/AssociationDetail';
import HyriaApplications from './containers/dashboard/HyriaApplications';
import Reports from './containers/dashboard/Reports';
import HyriaTasks from './containers/dashboard/HyriaTasks';
import HyriaApartmentClaims from './containers/dashboard/HyriaApartmentClaims';
import ConsentPage from './containers/consent';
import ChangeTenant from './containers/changeTenant';
import TerminationSigningPage from './containers/termination';
import PersonSearch from './containers/internal/PersonSearch';

// Auto-login avstängd för att testa BankID-flödet
// if (process.env.NODE_ENV === 'development') {
//   devAutoLogin();
// }

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Skyddad dashboard-routning - BRF ADMIN */}
        <Route path="/dashboard/*" element={<AdminRoute />}>
          <Route path="" element={<DashboardLayout />}>
          <Route index element={<DashboardOverview />} />
          <Route path="overview" element={<DashboardOverview />} />
          <Route path="applications" element={<Applications />} />
          <Route path="units" element={<Units />} />
          <Route path="documents" element={<Documents />} />
          <Route path="settings" element={<Settings />} />
          <Route path="export-import" element={<ExportImport />} />
          <Route path="audit-report" element={<AuditReportOrder />} />
          <Route path="credit-checks" element={<CreditChecks />} />
          </Route>
        </Route>
        {/* Hyria Admin Dashboard - ENDAST HYRIA_ADMIN */}
        <Route path="/hyria-dashboard/*" element={<HyriaAdminRoute />}>
          <Route path="" element={<HyriaDashboardLayout />}>
          <Route index element={<HyriaOverview />} />
          <Route path="overview" element={<HyriaOverview />} />
          <Route path="tasks" element={<HyriaTasks />} />
          <Route path="applications" element={<HyriaApplications />} />
          <Route path="associations" element={<HyriaAssociations />} />
          <Route path="associations/:associationId" element={<AssociationDetail />} />
          <Route path="apartment-claims" element={<HyriaApartmentClaims />} />
          <Route path="credit-checks" element={<CreditChecks />} />
          <Route path="audit" element={<SubletAudit />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<Settings />} />
          </Route>
        </Route>
        {/* Sidor utan header */}
        <Route path="/sign-in" element={<SignIn />} />
        {/* Bara i dev mot hyria-dev — uttrycket inlinas vid byggtid och är
            false i prod, så routen finns inte där. Se containers/devLogin. */}
        {DEV_LOGIN_ENABLED && <Route path="/dev-login" element={<DevLogin />} />}
        <Route path="/verify-sign-in" element={<VerifySignIn />} />
        <Route path="/bankid-test" element={<BankIDAuthTest />} />
        <Route path="/consent/:token" element={<ConsentPage />} />
        <Route path="/termination/:token" element={<TerminationSigningPage />} />
        {/* Hemlig intern sida - endast via direktlänk */}
        <Route path="/internal/folkbok-x7k9m2p4" element={<PersonSearch />} />
        {/* Main app routes - VANLIGA ANVÄNDARE & ADMIN */}
        <Route
          path="*"
          element={
            <Page>
              <Routes>
                <Route exact path="/" element={<ProtectedRoute />}>
                  <Route exact path="/" element={<HomeV3 />} />
                </Route>
                <Route exact path="/document" element={<ProtectedRoute />}>
                  <Route exact path="/document" element={<DocumentPage />} />
                </Route>
                <Route path="/create" element={<ProtectedRoute />}>
                  <Route path="/create" element={<Create />} />
                </Route>
                <Route path="/applications" element={<ProtectedRoute />}>
                  <Route path="/applications" element={<MyApplications />} />
                </Route>
                <Route path="/applications/:id/change-tenant" element={<ProtectedRoute />}>
                  <Route path="/applications/:id/change-tenant" element={<ChangeTenant />} />
                </Route>
                <Route
                  path="/email-confirmation-one"
                  element={<EmailConfirmationOne />}
                />
                <Route
                  path="/email-confirmation-two"
                  element={<EmailConfirmationTwo />}
                />
                <Route path="/tenant-confirmation" element={<TenantConfirmation />} />
                <Route
                  path="/tenant-background-control"
                  element={<TenantBackgroundControl />}
                />
              </Routes>
            </Page>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
